import axios from '../../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/statistics/Index/proNewsStatistics",{
        params: {
            ...params
        }
    } )
}
function EXPORT(params) {
    return  axios.get("/statistics/Index/proNewsExport",{
        params: {
            ...params
        }
    }  )
}

export default {
    GET_LIST,
    EXPORT,
};
